import type { OrganizationSubscriptionResponse } from 'generatedTypes/user/models';

import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
    initialState: {
        hasFetched: false,
        isFetching: false,
        stripeSubscriptions: null as OrganizationSubscriptionResponse[] | null
    },

    name: 'useStripeSubscriptions',

    reducers: {
        hasFetched: (state, action) => {
            state.hasFetched = action.payload;
        },

        isFetching: (state, action) => {
            state.isFetching = action.payload;
        },

        stripeSubscriptions: (state, action) => {
            state.stripeSubscriptions = action.payload;
        }
    }
});

export default slice.reducer;
